import { PhoneNumber, PhoneNumberInput } from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function PhoneNumberInputControl(props: CascadiaControlProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { formID } = useContext(CascadiaJsonFormContext);
  const inputName = slugify(props.path).split(".").pop();

  if (isSummaryForPath?.(props.path)) {
    return <SummaryItem label={props.label}>{props.data}</SummaryItem>;
  }

  const getNumberFromPhoneNumber = (
    phoneNumber: PhoneNumber | string | null
  ) => {
    if (phoneNumber && typeof phoneNumber === "object") {
      return phoneNumber.number;
    }
    return "";
  };

  return (
    <PhoneNumberInput
      errorMessage={props.touched && props.errors[0]}
      name={props.path}
      label={props.label}
      isRequired={props.required}
      isDisabled={!props.enabled}
      value={props.data}
      onBlur={props.setTouched}
      testID={formID ? `${formID}-${inputName}` : `${inputName}`}
      onChange={(value) => props.setValue(getNumberFromPhoneNumber(value))}
    />
  );
}

PhoneNumberInputControl.displayName = "PhoneNumberInputControl";

export const PhoneNumberInputControlRenderer = withCascadiaControlProps(
  PhoneNumberInputControl
);
